// extracted by mini-css-extract-plugin
export default {"header":"styles_header__K7s5u","root":"styles_root__QfdEy","title":"styles_title__tObnu","subtitle":"styles_subtitle__qarjY","button":"styles_button__M1Btw"};